import { render, staticRenderFns } from "./BtnRemoverVisita.vue?vue&type=template&id=6fd49903&"
import script from "./BtnRemoverVisita.vue?vue&type=script&lang=js&"
export * from "./BtnRemoverVisita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports